<script lang="ts" setup>
/**
 * <kt-input>
 * 
 * 
 * 
 */

import { ref, computed, watch, useSlots } from "vue";

const model = defineModel<string | number | null>();
const slots = useSlots();

const props = defineProps ({
    id: {
        type: String,
        default(props:any) {
            return "kinput-" + (Math.random() + "").replace(".", "");
        }
    },
    type: {
        type: String,
        default: "text"
    },
    inputClass: {
        type: String,
        default: "",
    },
    labelClass: {
        type: String,
        default: ""
    },
    col: {
        type: String,
        default: ""
    },
    label: {
        type: String,
        default: "",
    },
    readonly: {
        type: Boolean,
        default: false
    },    
    prefix: String,
    suffix: String,
    wrapClass: String,
    placeholder: String,
    floatin: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean
    },
    clear: {
        type: Boolean
    }
});

/*

const labelWidth = computed(() =>
{
    if (!props.col)
    {
        return "";
    }

    let num = parseInt((props.col + "").replace(/[^0-9]* /g, ""), 10);
    let dif = 12 - num;
    return (props.col + "").replace(num + "", dif);
});

watch(() => props.size, (val, old) => 
{
    if (0 < val)
    {
        let lbl = 12 - (+val);
        inputCol.value = `col-${props.break}-${val}`;
        labelCol.value = `col-form-label col-${props.break}-${lbl}`;
    }

    else
    {
        inputCol.value = "";
        labelCol.value = "";
    }
}, { immediate: true });
*/

const emit = defineEmits([
    "blur",
    "focus",
    "clear",
    "input",
]);

const clear = () =>
{
    emit("clear", model.value);
    model.value = "";
};


</script>

<template>

    <div :class="['kt-input-wrap row', props.wrapClass]">
        <label 
            v-if="props.label || slots.label" 
            :for="props.id"
            :class="['form-label my-auto', props.labelClass]"
        >
            <span v-html="props.label"></span>
            <slot name="label"></slot>
        </label>

        <div 
            :class="props.col"    
        >
            <div class="input-group">
                <slot name="prefix"></slot>
                <div v-if="props.prefix" class="input-group-text">
                    <span v-html="props.prefix"></span>
                </div>
                <input 
                    v-if="!props.type || props.type != 'textarea'"
                    v-model="model"
                    :id="props.id"
                    :class="['kt-input form-control', {'border-end-0': props.clear }, inputClass]"
                    :type="props.type"
                    :placeholder="props.placeholder"
                    :disabled="props.disabled"
                    :readonly="props.readonly"
                    @blur="$emit('blur')"
                    @focus="$emit('focus')"
                />
                <textarea 
                    v-if="props.type == 'textarea'"
                    v-model="model"
                    :id="props.id"
                    :class="['kinput form-control', {'border-end-0': props.clear }, inputClass]"
                    :type="props.type"
                    :placeholder="props.placeholder"
                    :disabled="props.disabled"
                    :readonly="props.readonly"
                    @blur="$emit('blur')"
                    @focus="$emit('focus')"
                ></textarea>
                <button 
                    v-if="props.clear"
                    class="btn bg-transparent border-0 border-bottom"
                    @click="clear()"
                >
                    <span>&times;</span>
                </button>
                <slot name="suffix"></slot>
                <div v-if="props.suffix" class="input-group-text">
                    <span v-html="props.suffix"></span>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>


</style>